// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../types/schema';

import { gql } from '@apollo/client';
export type Diagram_NodeFragment = { __typename?: 'PresentationDiagramNodeConfiguration', nodeID: string, label: string, type?: string | null, tileEmphasis?: string | null, iconShape?: string | null };

export type Diagram_EdgeFragment = { __typename?: 'PresentationDiagramEdgeDefinition', edgeID: string, sourceNodeID: string, targetNodeID: string, label?: string | null };

export const Operations = {
  Fragment: {
    Diagram_Node: 'Diagram_Node' as const,
    Diagram_Edge: 'Diagram_Edge' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const Diagram_NodeFragmentDoc = gql`
    fragment Diagram_Node on DiagramNode {
  nodeID
  label
  type
  tileEmphasis
  iconShape
}
    `;
export const Diagram_EdgeFragmentDoc = gql`
    fragment Diagram_Edge on DiagramEdge {
  edgeID
  sourceNodeID
  targetNodeID
  label
}
    `;